import { format, parseISO } from 'date-fns';

export const getUnixTimestamp = (): number => Math.round(new Date(Date.now()).getTime() / 1000);

export const formatDate = (form: string, date?: string): string => {
  if (!date) return '';

  try {
    return format(parseISO(date), form);
  } catch (e) {
    return '';
  }
};
